import { getStaticPathsGenerator } from '@cinch-nx/landing-feature-brand-page'

export { getStaticProps } from '@cinch-nx/landing-feature-brand-page'

const path = 'brands'
export const getStaticPaths = getStaticPathsGenerator(path)

export { BrandPage as default } from '@cinch-nx/landing-feature-brand-page'
